const PROFESSIONAL_TRAINING_STEPS = {
  pending: {
    step: 1,
    name: "Pendente",
    icon: "mdi-account-clock",
    color: "secondary",
    description: "Treinamento pendente"
  },
  in_training: {
    step: 2,
    name: "Em treinamento",
    icon: "mdi-account-filter",
    color: "primary",
    description: "Treinamento em andamento"
  },
  training_completed: {
    step: 3,
    name: "Treinamento completo",
    icon: "mdi-account-check",
    color: "success",
    description: "Treinamento completo"
  },
  training_incompleted: {
    step: 4,
    name: "Treinamento incompleto/reprovado",
    icon: "mdi-account-cancel",
    color: "accent",
    description: "Treinamento do profissional incompleto ou reprovado"
  }
};

// Methods
const isPendingTraining = status => {
  return status === "pending";
};

const isInTraining = status => {
  return status === "in_training";
};

const isTrainingApproved = status => {
  return status === "training_completed";
};

const isTrainingImcompleted = status => {
  return status === "training_incompleted";
};

// Filters
const getStatus = (value, field = null) => {
  const status = PROFESSIONAL_TRAINING_STEPS[value];

  return status && field ? status[field] : status;
};

export default {
  methods: {
    isPendingTraining,
    isInTraining,
    isTrainingApproved,
    isTrainingImcompleted
  },
  filters: {
    getStatus
  }
};



// WEBPACK FOOTER //
// ./src/mixins/professionals/professionalMixin.js